import { IconCloudCheck, IconCloudOff } from "@tabler/icons-react";
import { Badge, Card, Divider, Group, Stack, Text, ThemeIcon } from "@/components/ui";

/**
 * Card de estado del sistema · indicador con halo procesando cuando está
 * refetcheando + label adaptativa según el estado actual del healthcheck.
 *
 * Reemplaza `<Indicator processing>` de Mantine con un punto + `animate-ping`
 * (utilidad stock de Tailwind) posicionado en la esquina del ícono.
 */
export function SystemHealthCard({ ok, fetching, pending }: { ok: boolean; fetching: boolean; pending: boolean }) {
  const color = ok ? "exito" : "peligro";
  return (
    <Card padding="lg">
      <Stack gap="md">
        <Group justify="space-between">
          <Group gap="sm" wrap="nowrap">
            <div className="relative inline-flex">
              <ThemeIcon variant="filled" color={color} size="md">
                {ok ? <IconCloudCheck size={18} /> : <IconCloudOff size={18} />}
              </ThemeIcon>
              {fetching && (
                <span
                  className="absolute -right-0.5 -top-0.5 size-2.5 animate-ping rounded-full"
                  style={{ backgroundColor: `var(--color-${color}-500)` }}
                  aria-hidden="true"
                />
              )}
            </div>
            <Stack gap={0}>
              <Text fw={600} size="sm">
                {ok ? "Sistema operativo" : "Sistema sin respuesta"}
              </Text>
              <Text size="xs" c="dimmed">
                {pending ? "Verificando…" : ok ? "Health check cada 30s" : "API no responde"}
              </Text>
            </Stack>
          </Group>
        </Group>
        <Divider />
        <Group justify="space-between">
          <Text size="xs" c="dimmed">
            Último check
          </Text>
          <Badge variant="light" color={color} size="sm">
            {ok ? "Healthy" : "Down"}
          </Badge>
        </Group>
      </Stack>
    </Card>
  );
}
